export default __webpack_public_path__ + "static/media/normal.1ff0c34e.svg";